"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MasterCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const MasterCard = props => /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 19"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, /*#__PURE__*/_react.default.createElement("rect", {
  width: 24.5,
  height: 17.5,
  x: -0.25,
  y: -0.25,
  fill: "#FFF",
  stroke: "#E7E9EF",
  strokeWidth: 0.5,
  rx: 2
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#FF5E00",
  d: "M15.158 3.847c2.581 0 4.674 2.076 4.674 4.638s-2.093 4.64-4.674 4.64a4.676 4.676 0 0 1-3.033-1.11 4.668 4.668 0 0 1-3.03 1.11c-2.581 0-4.674-2.078-4.674-4.64s2.093-4.638 4.674-4.638c1.157 0 2.216.417 3.032 1.108a4.668 4.668 0 0 1 3.03-1.108Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#ED0006",
  d: "M9.095 3.847c1.157 0 2.216.417 3.032 1.108a4.615 4.615 0 0 0-.002 7.06 4.668 4.668 0 0 1-3.03 1.11c-2.581 0-4.674-2.078-4.674-4.64s2.093-4.638 4.674-4.638Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#F9A000",
  d: "M15.158 3.847c2.581 0 4.674 2.076 4.674 4.638s-2.093 4.64-4.674 4.64a4.676 4.676 0 0 1-3.032-1.11 4.614 4.614 0 0 0 0-7.06 4.676 4.676 0 0 1 3.032-1.108Z"
})));
exports.MasterCard = MasterCard;
MasterCard.displayName = "MasterCard";